import { Component } from "react";

// Catches WebGL/texture failures inside a Canvas and swaps in a static fallback.
export class SceneBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
